// extracted by mini-css-extract-plugin
export default {"iframe":"cCDbrxuPC0wX8qJSg5HZ"};